import React from "react";
import { Money } from "@/helpers/Money";
import { cn } from "@/helpers/utils";

export interface PriceDisplayProps {
  standardPrice: Money;
  discountPrice?: Money;
  showDiscountPrice?: boolean;
  size?: "base" | "lg" | "cart";
  alignment?: "left" | "right";
}

export const PriceDisplay = ({
  standardPrice,
  discountPrice,
  showDiscountPrice,
  size = "base",
  alignment = "right",
}: PriceDisplayProps) => {
  const displayPrice =
    showDiscountPrice && discountPrice ? discountPrice : standardPrice;
  const isCart = size === "cart";

  return (
    <div className="flex items-center whitespace-nowrap">
      {discountPrice && showDiscountPrice && (
        <span
          className={cn(
            "line-through",
            alignment == "left" && "order-2",
            isCart && "text-sm"
          )}
        >
          <span className="sr-only">Regular price</span>
          {standardPrice.format()}
        </span>
      )}
      <span
        className={cn(
          "font-semibold",
          alignment == "left" && "order-1 mr-2",
          alignment == "right" && "ml-2",
          isCart && "text-lg",
          size == "lg" && "text-6xl md:text-5xl xl:text-4xl"
        )}
      >
        <span className="sr-only">Current price</span>
        {displayPrice.format()}
      </span>
    </div>
  );
};
